import { render, staticRenderFns } from "./filter-product.vue?vue&type=template&id=bc30cc5e"
import script from "./filter-product.vue?vue&type=script&lang=js"
export * from "./filter-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports